import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import useContact from "../../../hooks/useContact";
import { getDefaultContactDetails } from "./contact-details.utils";
import BasicInfo from "./basic-info/basic-info";
import { ContactDetailsStyled } from "./contact-details.styles";
import { contactsCollection } from "../../../services/firebase";
import { useAuth } from "../../../context/AuthContext";
import ContactHeader from "./components/contact-header";
import { Typography } from "@mui/material";
import { isSomething } from "../../../utils/utils";
import { yupResolver } from "@hookform/resolvers/yup";
import { CreateContactValidations } from "../../../constants/validations";

const ContactDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("basic-info");
  const { userPermissions } = useAuth();
  const [currentContactData, setCurrentContactData] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const { data: contactDetails, refetch } = useContact(id);
  const contactData = getDefaultContactDetails(contactDetails);

  const form = useForm({
    defaultValues: contactData,
    resolver: yupResolver(CreateContactValidations()),
  });

  const { reset } = form;

  useEffect(() => {
    if (isSomething(contactDetails)) {
      reset(contactData);
    }
  }, [contactDetails]);

  const updateContactData = (updatedData) => {
    setCurrentContactData(updatedData);
  };

  const deleteContact = async (id) => {
    if (userPermissions === "General") {
      alert("You do not have permission to delete!");
      return;
    }
    const isConfirmed = window.confirm(
      "Are you sure? If you delete this contact, all the information will be lost."
    );
    if (isConfirmed) {
      try {
        await contactsCollection.doc(id).delete();
        navigate("/contactsview/");
      } catch (error) {
        console.error("Error deleting:", error);
        alert("Failed to delete!");
      }
    }
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);
      const formData = form.getValues();

      const updatedContactData = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        title: formData.title,
        companyID: formData.companyID,
        type: formData.type,
        contactState: formData.contactState,
        emailAddress: formData.emailAddress,
        phoneNumber: formData.phoneNumber,
        contactNotes: formData.contactNotes,
      };

      await contactsCollection.doc(id).update(updatedContactData);
      refetch();
      updateContactData(updatedContactData);

      setIsEditMode(false);
    } catch (error) {
      console.error("Error updating contact:", error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <ContactDetailsStyled>
      <ContactHeader
        contactDetails={contactDetails}
        activeTab={activeTab}
        isEditMode={isEditMode}
        setIsEditMode={setIsEditMode}
        isSaving={isSaving}
        handleSave={handleSave}
        isSaveEnabled={form?.formState?.isValid}
      />

      <div>
        {/* <div className="details-wrapper">
          <CustomTabs
            activeTab={activeTab}
            handleChange={setActiveTab}
            tabsList={[
              { label: "Basic Info", value: "basic-info" },
              // { label: "..", value: "" },
            ]}
          />
        </div> */}

        <div className="tab-content">
          {activeTab === "basic-info" && (
            <BasicInfo
              refetch={refetch}
              contactData={contactData}
              updateContactData={updateContactData}
              isEditMode={isEditMode}
              form={form}
            />
          )}
        </div>

        <div className="footer">
          <hr></hr>
          <div className="space-between">
            <div className="created">
              <Typography variant="body3">
                Created By: {contactData.createdBy}
              </Typography>
              <Typography variant="body3">
                Created Date: {contactData.dateCreated}
              </Typography>
            </div>
            {/* <div className="delete-icon">
              {userPermissions !== "General" && (
                <Button
                  endIcon={<DeleteIcon color="#fff" />}
                  onClick={() => deleteContact(id)}
                  color={"error"}
                  variant={"filled"}
                >
                  Delete Contact
                </Button>
              )}
            </div> */}
          </div>
        </div>
      </div>
    </ContactDetailsStyled>
  );
};

export default ContactDetails;
